import type { WebhookEventType } from 'src/constants/webhook/enums'
import type { WebhookSubscription } from 'src/interfaces/webhook'

/**
 * The backend's `findAllByPartnerId` has no `ORDER BY`, so ordering is the client's job. Sorts a
 * COPY — the input is read straight out of Redux state and must never be mutated in place.
 * Rows with no `createdAt` sort last rather than being dropped.
 */
export const sortSubscriptionsByNewest = (
  subscriptions: WebhookSubscription[],
): WebhookSubscription[] => {
  return [...subscriptions].sort((first, second) => {
    return (second.createdAt ?? 0) - (first.createdAt ?? 0)
  })
}

/**
 * The client-side half of the send-test gate. `POST /webhooks/send` throws
 * `BadRequestException('No active webhook subscription found for this partner with event type X')`
 * when nothing active covers the chosen event, and this answers the same question locally so the
 * admin sees it while picking rather than after a live call.
 */
export const hasActiveSubscriptionForEvent = (
  subscriptions: WebhookSubscription[],
  eventType: WebhookEventType | null,
): boolean => {
  if (eventType === null) {
    return false
  }

  return subscriptions.some((subscription) => {
    return subscription.isActive && subscription.events.includes(eventType)
  })
}
